import {HttpContextToken, HttpInterceptorFn} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {inject} from '@angular/core';
import {ToastService} from '../toast';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

function getTranslationKeys(error: any): {title: string; detail: string} {
  if (error.error) {
    const title =
      typeof error.error.translationTitleKey === 'string'
        ? error.error.translationTitleKey
        : 'error.generic';
    const detail = error.error.translationDetailKey;
    return {title, detail};
  }

  if (error.status === 401) {
    return {title: 'error.unauthorized', detail: 'error.unauthorized.detail'};
  }

  return {title: 'error.generic', detail: 'error.generic.detail'};
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      const skipToastOn404 = req.headers.get('X-Skip-Error-Toast-On-404') === 'true';
      const skipToastOn409 = req.headers.get('X-Skip-Error-Toast-On-409') === 'true';

      if (
        req.context.get(SKIP_ERROR_TOAST) ||
        (error.status === 404 && skipToastOn404) ||
        (error.status === 409 && skipToastOn409)
      ) {
        return throwError(() => error);
      }

      const {title, detail} = getTranslationKeys(error);
      toastService.showError(title, detail);
      return throwError(() => error);
    }),
  );
};
